import React from 'react';

import {AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import {MODEL_NAMES} from 'results/ResultsNamingConstants';
import * as ModalContainer from 'ui-library/ModalContainer';

import {configureMapColumnNamesModalPane} from '../panes/MapColumnNamesModalPane';
import ShowErrorsModalPane from '../panes/ShowErrorsModalPane';
import UploadSpreadsheetModalPane from '../panes/UploadSpreadsheetModalPane';
import * as SpreadsheetBulkImportActions from '../SpreadsheetBulkImportActions';
import {
  COLUMN_TYPE,
  IMPORT_TYPE,
  Pane,
  PaneKey,
  SPREADSHEET_BULK_IMPORT_KEY,
} from '../SpreadsheetBulkImportConstants';
import SpreadsheetBulkImportModalContainer from '../SpreadsheetBulkImportModalContainer';
import * as SpreadsheetBulkImportUtil from '../SpreadsheetBulkImportUtil';

interface CreateRunResultsFlowProps {
  onImportRows: () => void;
  assayRunId: string;
  resultSchema: AssaySchema;
}

interface Closeable {
  onRequestClose: () => void;
}

class CreateRunResultsFlow extends React.Component<CreateRunResultsFlowProps & Closeable> {
  static open(props: CreateRunResultsFlowProps): void {
    ModalContainer.open(
      SPREADSHEET_BULK_IMPORT_KEY,
      <CreateRunResultsFlow {...props} onRequestClose={SpreadsheetBulkImportActions.closeModal} />
    );
  }

  _getPanes = (): Array<Pane> => [
    {
      paneKey: PaneKey.UPLOAD_SPREADSHEET,
      configuration: UploadSpreadsheetModalPane.configure({
        getExampleImageURL(): string {
          return SpreadsheetBulkImportUtil.getExampleImageURLForTagSchema(null);
        },
      }),
    },
    {
      paneKey: PaneKey.MAP_COLUMN_NAMES,
      configuration: configureMapColumnNamesModalPane({
        getValidColumnTypes(): Array<COLUMN_TYPE> {
          return [COLUMN_TYPE.RESULT_SCHEMA_FIELD, COLUMN_TYPE.IGNORE];
        },
        getRequiredColumnsError(): null {
          return null;
        },
        onValidateSpreadsheet: () => {
          SpreadsheetBulkImportActions.validateCreateResultsForRun(
            this.props.assayRunId,
            this.props.resultSchema.id
          );
        },
      }),
    },
    {
      paneKey: PaneKey.SHOW_ERRORS,
      configuration: ShowErrorsModalPane.configure({
        enableReplaceLinkWithText: false,
        enableSkipErrors: false,
      }),
    },
  ];

  _handleImportFromSpreadsheet = (): void => {
    SpreadsheetBulkImportActions.createResultsForRun(
      this.props.assayRunId,
      this.props.resultSchema.id,
      () => {
        this.props.onImportRows();
      }
    );
  };

  override render = (): JSX.Element => (
    <SpreadsheetBulkImportModalContainer
      importType={IMPORT_TYPE.RUN_RESULTS}
      initialSettings={{
        initialResultSchemaId: this.props.resultSchema.id,
      }}
      onImportFromSpreadsheet={this._handleImportFromSpreadsheet}
      onRequestClose={this.props.onRequestClose}
      panes={this._getPanes()}
      title={`Import ${MODEL_NAMES.results} into ${MODEL_NAMES.run}`}
    />
  );
}

export default CreateRunResultsFlow;
